import { PermissionGate } from "@/components/common/PermissionGate"
import { Button } from "@/components/ui/button"
import { PERMISSIONS } from "@/constants/permissions"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Pencil } from "lucide-react"
import { DetailPanelHeader } from "./DetailPanelHeader"

interface Props {
  label: string
  name: string
  subtitle?: string | null
  editing?: boolean
  onEdit?: () => void
}

/**
 * Master Data's Fields header — the same detail-pane header the other panels use, with
 * Edit as its only action (the collapse button comes from DetailPanelHeader). Every
 * write behind this pencil (patchSupplier / patchArticle / patchCustomer / etc.)
 * gates on MC_MASTER_DATA_EDIT, so the button itself disables here rather than
 * clicking through to a 403.
 */
export function FieldsSectionHeader({
  label,
  name,
  subtitle,
  editing,
  onEdit,
}: Props) {
  const { translate } = useTranslation()

  return (
    <DetailPanelHeader
      label={label}
      title={name}
      subtitle={subtitle ?? undefined}
      actions={() =>
        onEdit &&
        !editing && (
          <PermissionGate permission={PERMISSIONS.MC_MASTER_DATA_EDIT}>
            <Button
              size="sm"
              variant="outline"
              className="h-[30px] w-[30px]"
              onClick={onEdit}
              aria-label={translate("MC_MD_DETAIL_EDIT_BTN")}
            >
              <Pencil size={14} />
            </Button>
          </PermissionGate>
        )
      }
    />
  )
}
